//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

import myQuery from '../search-shared/components/Query';
import myFilters from "../search-shared/components/Filters";
import myTags from "../search-shared/components/Tags";
import mySort from "./components/Sort";
import myResultCount from "../search-shared/components/ResultCount";
import myResults from "./components/Results";
import myLoadMore from "../search-shared/components/LoadMore";

export default {
  name: "SearchApp",
	components: {
		myQuery,
		myFilters,
		myTags,
		mySort,
		myResultCount,
		myResults,
		myLoadMore,
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters([
			"reloading",
			"currentPage"
		]),
	},
	methods: {},
	mounted() {},
};
